import { render } from "./NotYetOpen.vue?vue&type=template&id=47e492ad&scoped=true"
import script from "./NotYetOpen.vue?vue&type=script&lang=js"
export * from "./NotYetOpen.vue?vue&type=script&lang=js"

import "./NotYetOpen.vue?vue&type=style&index=0&id=47e492ad&scoped=true&lang=scss"

import exportComponent from "E:\\Project\\one-code-pass\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47e492ad"]])

export default __exports__